// extracted by mini-css-extract-plugin
export default {"chip":"chip_chip__q8aEy","green":"chip_green__R8fdM","orange":"chip_orange__8sV4z","blue":"chip_blue__6D4Ue"};